import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Typography, Container, Paper, Button, Box } from '@mui/material';

const UnauthorizedPage = () => {
  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ p: 4, mt: 8, textAlign: 'center' }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Access Denied
        </Typography>
        
        <Typography variant="body1" paragraph>
          You don't have permission to access this page.
        </Typography>
        
        <Box mt={3}>
          <Button
            component={RouterLink}
            to="/dashboard"
            variant="contained"
            color="primary"
          >
            Go to Dashboard
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default UnauthorizedPage;